import { WellCurveCatalog } from 'features/well-viewer/components/WellCurveCatalog';

export function WellCatalog(){

    return (<WellCurveCatalog onChange={(t)=> console.log(t)} ></WellCurveCatalog>);
}